import React from 'react';
import PropTypes from 'prop-types';
import CameraIcon from '../../../assets/images/companion/camera.svg';
import phrasesType from '../../proptypes/phrases';

const Surveillance = ({
  surveillanceComplete,
  hqSurveillancePath,
  phrases: {
    companionSessions: {
      surveillance,
      gameComplete,
      surveillanceZone,
      playNow,
    },
  },
}) => (
  <article className="game-well-surveillance">
    <div className="icon-coloured">
      <CameraIcon />
    </div>
    <h2 className="h2 display-font text-center">{surveillance}</h2>
    {surveillanceComplete ? (
      <p className="text-center">{gameComplete}</p>
    ) : (
      <>
        <p className="text-center">{surveillanceZone}</p>
        <a href={hqSurveillancePath} role="button" className="btn btn-secondary w-100">{playNow}</a>
      </>
    )}
  </article>
);

Surveillance.propTypes = {
  surveillanceComplete: PropTypes.bool.isRequired,
  hqSurveillancePath: PropTypes.string.isRequired,
  phrases: phrasesType.isRequired,
};

export default Surveillance;
